import React from 'react';
import { Box, LinearProgress, alpha } from '@mui/material';

interface Threshold {
  value: number;
  color: string;
  label: string;
}

const DEFAULT_THRESHOLDS: Threshold[] = [
  { value: 25, color: '#e65100', label: 'Suficiente' },
  { value: 50, color: '#1565c0', label: 'Bom' },
  { value: 75, color: '#2e7d32', label: 'Otimo' },
];

interface ProgressBarWithMetasProps {
  value: number;
  color?: string;
  thresholds?: Threshold[];
  height?: number;
  showThresholds?: boolean;
}

const ProgressBarWithMetas: React.FC<ProgressBarWithMetasProps> = ({
  value,
  color = '#1565c0',
  thresholds = DEFAULT_THRESHOLDS,
  height = 8,
  showThresholds = true,
}) => {
  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <LinearProgress
        variant="determinate"
        value={Math.min(value, 100)}
        sx={{
          height,
          borderRadius: height / 2,
          bgcolor: alpha(color, 0.08),
          '& .MuiLinearProgress-bar': { borderRadius: height / 2, bgcolor: color },
        }}
      />
      {showThresholds && thresholds.map((t) => (
        <Box
          key={t.value}
          sx={{
            position: 'absolute',
            left: `${t.value}%`,
            top: 0,
            bottom: 0,
            width: '1px',
            borderLeft: `1px dashed ${alpha(t.color, 0.4)}`,
            pointerEvents: 'none',
          }}
        />
      ))}
    </Box>
  );
};

export default ProgressBarWithMetas;
